import IMask from '../../_scripts/plugins/imask/imask.min';

export default class Contacts {

  constructor() {
    this.feedbackForm = document.querySelector('.feedback__form');
    this.feedbackInputAll = document.querySelectorAll('.feedback__input');
    this.feedbackTextareaAll = document.querySelectorAll('.feedback__textarea');
    this.inputPhone = document.querySelector('.feedback__input--phone');
    this.successMessage = document.querySelector('.feedback__success');
    this.feedbackButtonMessage = document.querySelector('.feedback__button-apply');
  }

  _focusFormItem(target) {
    [...target].map(element => {
      element.addEventListener('focus', () => {
        element.classList.add('focus');
      });

      element.addEventListener('blur', () => {
        element.value.length === 0
          && element.classList.remove('focus');
      });
    });
  };

  _phoneMask() {
    return new IMask(this.inputPhone, {
      mask: '+{7} (000) 000-00-00'
    });
  }

  _submitForm() {
    const formData = new FormData(this.feedbackForm);
    const formSrc = this.feedbackForm.dataset.src;

    fetch(formSrc, {
      method: 'POST',
      body: formData
    })
      .then(response => {
        response.status === 200 &&
          this._showMessageForm();
      })
      .catch(error => {
        console.error(error);
      });
  }

  _showMessageForm() {
    this.feedbackForm.classList.toggle('feedback__form--hide');
    this.successMessage.classList.toggle('feedback__success--visible');
  }

  init() {
    [...this.feedbackInputAll].forEach(i => i.value = "");
    [...this.feedbackTextareaAll].forEach(t => t.value = "");
    if (this.feedbackForm) {
      this._phoneMask();
      this._focusFormItem(this.feedbackInputAll);
      this._focusFormItem(this.feedbackTextareaAll);

      this.feedbackForm.addEventListener('submit', e => {
        e.preventDefault();
        this._submitForm();
      });

      this.feedbackButtonMessage.addEventListener('click', () => {
        this.feedbackForm.reset();
        [...this.feedbackForm.querySelectorAll('.feedback__field')].map(field => {
          field.firstElementChild.classList.remove('focus');
        });
        this._showMessageForm();
      });
    }
  }
}